<script>
import { isInIframe } from '@/utils/iframe-detect'
import { Settings } from '@/Settings'
import { viewToReport, reportLineSheetView } from '@/utils/lineSheetViewTracking'

/**
 * Reports a line sheet visit from a public wishlist page (KP-3741).
 *
 * Both public wishlist routes need this, and both are reachable from a
 * sequence email: plg-go-be's link matcher accepts an optional version
 * prefix, so /wishlist/public/<token> and /v2/wishlist/public/<token> are
 * equally valid targets. A visit that lands on the legacy route is the same
 * buyer opening the same collection, so it has to count the same way.
 *
 * Reuses VUE_APP_PLG_URL, which every environment's settings.json already
 * carries — a key of its own would have to be added per environment before
 * anything was counted, which is the failure KP-3741 already shipped with.
 *
 * Never allowed to affect the page — not even a console line. Read through
 * getOptionalConfig rather than getConfig, which reports a missing key as a
 * misconfiguration; a missing settings key, a blocked beacon or a thrown
 * error all end the same way, with the buyer looking at the collection and
 * us simply not getting the metric.
 */
export default {
  watch: {
    // A new token on the same page is a new visit.
    '$route.params.publicToken': function onPublicTokenChange() {
      this.reportLineSheetVisit()
    },
  },
  methods: {
    reportLineSheetVisit() {
      try {
        const trackedLinkId = viewToReport(this.$route.query, isInIframe())
        if (!trackedLinkId) return
        reportLineSheetView(trackedLinkId, Settings.getOptionalConfig('VUE_APP_PLG_URL'))
      } catch (e) {
        // Settings not loaded, or the key is absent. Nothing to do.
      }
    },
  },
}
</script>
